import React from "react";

import { AddressForm as AddressFormA } from "./AddressFormA";
import { AddressForm as AddressFormB } from "./AddressFormB";

export interface MinimalBillingAddress {
    country: string;
    postal_code: string;
}

export interface AddressFormProps {
    initialAddress: MinimalBillingAddress;
    onChange: ({ address, isAddressValid }: { address: MinimalBillingAddress, isAddressValid: boolean }) => void;
    disabled?: boolean;
    nextFieldRef?: React.RefObject<any>;
}

export function AddressForm({ variant = "A", ...props }: { variant?: "A" | "B" } & AddressFormProps) {
    const Component = variant === "A" ? AddressFormA : AddressFormB;
    return <Component {...props} />;
}

